import { useParkingCreateStore } from '@shared/stores/useParkingCreateStore';
import { useParkingSearchStore } from '@shared/stores/useParkingSearchStore';
import { useReservationConsentStore } from '@shared/stores/useReservationConsentStore';

export const resetUserStores = (): void => {
  useParkingCreateStore.getState().reset();
  useParkingSearchStore.getState().resetSearch();
  useReservationConsentStore.getState().reset();
};
